import Vue from "vue";
import Router from "vue-router";
import { APP_LOGGER } from "@/app/logger";

APP_LOGGER.debug("Install vue-router", { Router });
Vue.use(Router);
